<script setup lang="ts">
import { computed, useTemplateRef, watch } from 'vue'

import { useElementSize } from '@vueuse/core'

type Props = {
  shouldShowNavigation: boolean
  translateShift: number
}

const props = defineProps<Props>()

type Emits = { carouselViewportWidth: [number] }
const emit = defineEmits<Emits>()

// state
const carouselViewportElement = useTemplateRef('carouselViewportElement')
const { width: viewportWidth } = useElementSize(carouselViewportElement)

const translateShiftPixels = computed(() => {
  return props.translateShift < 0
    ? `${props.translateShift}px`
    : `-${props.translateShift}px`
})
watch(
  viewportWidth,
  () => {
    emit('carouselViewportWidth', viewportWidth.value)
  },
  { immediate: true },
)
</script>

<template>
  <div
    class="w-full"
    :class="{ 'overflow-hidden': shouldShowNavigation }"
  >
    <div
      ref="carouselViewportElement"
      class="flex gap-x-1.5"
      :class="{ 'justify-center': !shouldShowNavigation }"
      :style="{
        transform: `${shouldShowNavigation ? `translateX(${translateShiftPixels})` : ''}`,
        transition: 'transform 0.5s ease',
      }"
    >
      <slot />
    </div>
  </div>
</template>
